module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-6 px-3"
  }, [_c('div', {
    staticClass: "flex-grow grid grid-cols-1 lg:grid-cols-2 gap-x-8"
  }, [_c('div', [_c('div', {
    staticClass: "flex justify-between items-center pb-7 border-b"
  }, [_vm._m(0), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "disabled": _vm.is_saving,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.require_submission),
      callback: function($$v) {
        _vm.require_submission = $$v
      },
      expression: "require_submission"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "py-7 border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', [_c('span', {
    staticClass: "text-base font-semibold font-poppins text-gray-700"
  }, [_vm._v("Anonymity")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:anonymity-info.right",
      arg: "anonymity-info",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "px-2 text-gray-600 hover:text-gray-700"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Students will be anonymous to each other with pseudonymous of\n              accomplished people from history.\n            ")])]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "disabled": _vm.is_saving,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.anonymity_status),
      callback: function($$v) {
        _vm.anonymity_status = $$v
      },
      expression: "anonymity_status"
    }
  })], 1), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "anonymity-info",
      "width": 380
    }
  }, [_c('div', {
    staticClass: "px-4 py-3"
  }, [_vm._v("\n            Students will be randomly "), _c('b', {
    staticClass: "font-semibold text-gray-700"
  }, [_vm._v("assigned a different identity")]), _vm._v(" for each\n            discussion. The teacher will never be anonymous in the discussion.\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "py-7 border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', [_c('span', {
    staticClass: "text-base font-semibold font-poppins text-gray-700"
  }, [_vm._v("Close Date")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:close-date-info.right",
      arg: "close-date-info",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "px-2 text-gray-600 hover:text-gray-700"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Set a date and time to automatically close the RoundTable.\n            ")])]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "disabled": _vm.is_saving,
      "sync": true,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.close_date.enabled),
      callback: function($$v) {
        _vm.$set(_vm.close_date, "enabled", $$v)
      },
      expression: "close_date.enabled"
    }
  })], 1), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "close-date-info",
      "width": 350
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 text-gray-700"
  }, [_vm._v("\n            This feature will "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("automatically close the RoundTable")]), _vm._v(" at the date\n            and time provided. It will also send an email reminder to students\n            24 hours before closing time.\n          ")])]), _vm._v(" "), (_vm.close_date.enabled) ? _c('div', {
    staticClass: "mt-4 pl-2.5 flex flex-col sm:flex-row"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded px-5 py-2 flex items-center"
  }, [_c('DatePicker', {
    staticClass: "cursor-pointer bg-gray-100 w-full relative",
    attrs: {
      "placeholder": "Select a date",
      "config": _vm.config,
      "disabled": _vm.is_saving
    },
    model: {
      value: (_vm.close_date.date),
      callback: function($$v) {
        _vm.$set(_vm.close_date, "date", $$v)
      },
      expression: "close_date.date"
    }
  }), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center mt-2 sm:mt-0 sm:ml-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hard_close_enable),
      expression: "hard_close_enable"
    }],
    staticClass: "mr-2.5 cursor-pointer",
    attrs: {
      "disabled": _vm.is_saving,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hard_close_enable) ? _vm._i(_vm.hard_close_enable, null) > -1 : (_vm.hard_close_enable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.hard_close_enable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hard_close_enable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.hard_close_enable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hard_close_enable = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "py-7 border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', [_c('span', {
    staticClass: "text-base font-semibold font-poppins text-gray-700"
  }, [_vm._v("Email Notifications")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:email-info.right",
      arg: "email-info",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "px-2 text-gray-600 hover:text-gray-700"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Participants can receive an email notification for comments and\n              replies.\n            ")])]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "disabled": _vm.is_saving,
      "sync": true,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.is_email_notifications_enable),
      callback: function($$v) {
        _vm.is_email_notifications_enable = $$v
      },
      expression: "is_email_notifications_enable"
    }
  })], 1), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "email-info",
      "width": 420
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 text-gray-700"
  }, [_vm._v("\n            With email notifications turned on, participants will receive an\n            email "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("when someone")]), _vm._v(" comments on their submission or replies to\n            their comment. They will not receive email notifications if they\n            are logged into Parlay.\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "py-7 border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', [_c('span', {
    staticClass: "text-base font-semibold font-poppins text-gray-700"
  }, [_vm._v("Genie Feedback")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:feedback-info.right",
      arg: "feedback-info",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "px-2 text-gray-600 hover:text-gray-700"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Participants can use A.I. to help them improving submissions\n              based on RoundTable Assessment Criterias.\n            ")])]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "disabled": _vm.is_saving,
      "sync": true,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.is_genie_feedback_enable),
      callback: function($$v) {
        _vm.is_genie_feedback_enable = $$v
      },
      expression: "is_genie_feedback_enable"
    }
  })], 1), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "feedback-info",
      "width": 480
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 text-gray-700"
  }, [_vm._v("\n            Enabling Genie Feedback provides participants with the choice to "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("receive instant feedback")]), _vm._v(" on their submissions, \n            which is tailored to the criteria "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("set by the instructor ")]), _vm._v("for the RoundTable. \n            If no specific criteria are set, participants will receive general feedback. \n            The instructor "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("can view this feedback")]), _vm._v(" as well as any revisions made by the participant in response to the feedback.\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "py-7"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "pl-2.5"
  }, [_c('div', [_c('span', {
    staticClass: "text-base font-semibold font-poppins text-gray-700"
  }, [_vm._v("Assessment")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:assessment-info.right",
      arg: "assessment-info",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "px-2 text-gray-600 hover:text-gray-700"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n              Teacher can assess students based on predefined criteria.\n            ")])]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "disabled": _vm.is_saving,
      "sync": true,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.assessment_status),
      callback: function($$v) {
        _vm.assessment_status = $$v
      },
      expression: "assessment_status"
    }
  })], 1), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "assessment-info",
      "width": 400
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 text-gray-700"
  }, [_vm._v("\n            Create "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("your own criteria")]), _vm._v(" or use "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("one of the defaults")]), _vm._v(". Set a Max\n            Score for a rubric-style assessment, or leave it off for a\n            tally-based approach.\n          ")])]), _vm._v(" "), (_vm.assessment_status) ? _c('div', {
    staticClass: "mt-4 pl-2.5"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row"
  }, [_c('div', {
    staticClass: "bg-gray-100 border border-solid border-gray-200 text-gray-500 rounded-full p-0.5 max-w-xxs"
  }, [_c('button', {
    staticClass: "px-3.5 py-1 rounded-full font-poppins text-gray-700",
    class: _vm.max_score_enabled === false ? 'bg-white border border-solid border-gray-200' : '',
    on: {
      "click": function($event) {
        _vm.max_score_enabled = !_vm.max_score_enabled
      }
    }
  }, [_vm._v("\n                Tally\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "px-3.5 py-1 rounded-full font-poppins text-gray-700",
    class: _vm.max_score_enabled === true ? 'bg-white border border-solid border-gray-200' : '',
    on: {
      "click": function($event) {
        _vm.max_score_enabled = !_vm.max_score_enabled
      }
    }
  }, [_vm._v("\n                Rubric\n              ")])]), _vm._v(" "), (_vm.max_score_enabled) ? _c('div', {
    staticClass: "flex items-center mt-1 sm:mt-0 sm:ml-5"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ml-5 flex items-center space-x-1"
  }, [_c('button', {
    staticClass: "sample text-gray-500 text-xs hover:bg-gray-100 rounded-full h-7 w-7",
    attrs: {
      "disabled": Number(_vm.point_scale) === 0
    },
    on: {
      "click": function($event) {
        _vm.point_scale -= 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.point_scale),
      expression: "point_scale"
    }],
    staticClass: "w-10 h-7 rounded text-center custom-border",
    attrs: {
      "disabled": _vm.is_saving
    },
    domProps: {
      "value": (_vm.point_scale)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.point_scale = $event.target.value
      }, _vm.inputed]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sample text-gray-500 text-xs hover:bg-gray-100 rounded-full h-7 w-7",
    on: {
      "click": _vm.addPoint
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.getCourseDetail.points_settings.peer_rewards), function(point_type, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "flex justify-between border border-solid border-gray-200 rounded px-4 space-x-2 py-2.5"
    }, [_c('div', {
      staticClass: "w-full flex items-center space-x-3"
    }, [_c('Popper', {
      attrs: {
        "append-to-body": true,
        "prevent-default": true,
        "trigger": "clickToToggle",
        "options": {
          placement: 'right',
          modifiers: {
            offset: {
              offset: '0,8px'
            }
          }
        }
      },
      on: {
        "show": _vm.openPopper,
        "hide": _vm.closePopper
      }
    }, [_c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: (_vm.closePopper),
        expression: "closePopper"
      }],
      staticClass: "popper bg-white rounded-md shadow-sm relative w-64 pb-4"
    }, [(point_type.title) ? _c('div', {
      staticClass: "py-2.5 font-semibold text-sm font-poppins text-left w-full px-3"
    }, [_vm._v("\n                      " + _vm._s(point_type.title) + "\n                    ")]) : _vm._e(), _vm._v(" "), (point_type.description) ? _c('div', {
      staticClass: "text-left text-xs flex flex-col px-3 text-gray-700 font-poppins font-light"
    }, [_c('div', {
      staticClass: "html-content font-poppins font-light",
      domProps: {
        "innerHTML": _vm._s(typeof point_type.description === 'object' ? point_type.description.join('. ') : point_type.description)
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.max_score_enabled === true) ? _c('div', {
      staticClass: "mt-4 px-3"
    }, [(point_type.points_description && point_type.points_description.length > 0) ? _c('div', _vm._l((point_type.points_description), function(point) {
      return _c('div', {
        staticClass: "flex flex-col text-left text-xs space-y-2"
      }, [(point.description !== '') ? _c('div', {
        staticClass: "flex items-center space-x-1 mb-2"
      }, [_c('div', {}, [_c('span', {
        staticClass: "font-semibold font-poppins text-gray-800"
      }, [_vm._v("(" + _vm._s(point.value) + ") Point: ")]), _c('span', {
        staticClass: "text-gray-700"
      }, [_vm._v(_vm._s(point.description))])])]) : _vm._e()])
    }), 0) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "h-full items-center font-semibold hover:underline font-poppins text-gray-600 hover:text-gray-700",
      attrs: {
        "slot": "reference",
        "type": "button"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa-solid fa-circle-info"
    })])]), _vm._v(" "), _c('button', {
      staticClass: "text-sm cursor-pointer text-gray-700 hover:underline",
      on: {
        "click": function($event) {
          return _vm.handleEditAssessmentPoint(point_type)
        }
      }
    }, [_vm._v(_vm._s(point_type.title))])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_points),
        expression: "selected_points"
      }],
      staticClass: "cursor-pointer",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": point_type.tag,
        "checked": Array.isArray(_vm.selected_points) ? _vm._i(_vm.selected_points, point_type.tag) > -1 : (_vm.selected_points)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected_points,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = point_type.tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected_points = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected_points = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_points = $$c
          }
        }
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3 flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.point_title),
      expression: "point_title"
    }],
    staticClass: "px-3 py-2 w-full border rounded border-solid border-gray-200 placeholder-gray-400 bg-white",
    attrs: {
      "type": "text",
      "placeholder": 'Enter a new criteria title...'
    },
    domProps: {
      "value": (_vm.point_title)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleCreatePoint()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.point_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "bg-blueGray-700 rounded text-white px-3 py-1.5 border border-solid border-blueGray-700 disabled:opacity-50",
    attrs: {
      "disabled": _vm.point_title === '' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.handleCreatePoint()
      }
    }
  }, [_vm._v("\n              Add\n            ")])])], 2) : _vm._e()], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mt-3 md:mt-0"
  }, [_c('span', {
    staticClass: "text-base font-semibold font-poppins text-gray-700"
  }, [_vm._v("Peer Feedback Questions & Sentence Stems")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:peer-feedback-info.right",
      arg: "peer-feedback-info",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "px-2"
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-gray-600"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n        Students will see these peer feedback questions when they respond to\n        their classmates.\n      ")]), _vm._v(" "), _c('popover', {
    staticClass: "bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "peer-feedback-info",
      "width": 350
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 text-gray-700"
  }, [_vm._v("\n          The students can click on the "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("question to auto-populate")]), _vm._v(" it in their comment box.\n        ")])]), _vm._v(" "), _vm._l((_vm.peer_feedback_questions), function(q, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-4 flex justify-between"
    }, [_c('span', {
      staticClass: "w-10/12 text-sm"
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(q.question))]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [(q.is_custom) ? _c('i', {
      staticClass: "fas fa-trash-alt mr-1.5 text-red-200 hover:text-red-700 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.deletePeerQuestion(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fas fa-edit mr-1.5 text-gray-200 hover:text-gray-500 cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving
      },
      on: {
        "click": function($event) {
          return _vm.editPeerQuestion(index)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (q.is_active),
        expression: "q.is_active"
      }],
      staticClass: "cursor-pointer",
      attrs: {
        "disabled": _vm.is_saving,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(q.is_active) ? _vm._i(q.is_active, null) > -1 : (q.is_active)
      },
      on: {
        "change": function($event) {
          var $$a = q.is_active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(q, "is_active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(q, "is_active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(q, "is_active", $$c)
          }
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-5 flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.peer_question_new),
      expression: "peer_question_new"
    }],
    staticClass: "px-4 py-2 w-full bg-input rounded placeholder-gray-300",
    attrs: {
      "type": "text",
      "placeholder": 'New Question',
      "disabled": _vm.is_saving
    },
    domProps: {
      "value": (_vm.peer_question_new)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addPeerQuestion.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.peer_question_new = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "sample fas fa-plus-circle text-2xl ml-3 text-gray-400 cursor-pointer",
    attrs: {
      "disabled": _vm.is_saving
    },
    on: {
      "click": _vm.addPeerQuestion
    }
  })])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-2.5"
  }, [_c('p', {
    staticClass: "text-base font-semibold font-poppins text-gray-700"
  }, [_vm._v("Require Submission")]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n            Students must submit a unique response before they can see and\n            comment on their classmate's ideas.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "cursor-pointer",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs text-gray-500"
  }, [_c('p', {
    staticClass: "font-semibold"
  }, [_vm._v("Hard Close")]), _vm._v(" "), _c('p', [_vm._v("Disable contributions after close date.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "text-sm font-semibold font-poppins text-gray-700"
  }, [_vm._v("Max Score")]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-600 text-xs font-poppins"
  }, [_vm._v("For each criteria")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6bbfe3b6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/tabs/settingsTab.vue
// module id = 1057
// module chunks = 61